import React, { FunctionComponent } from 'react'
import { vn } from 'vend-number'
import { T } from '@transifex/react'
import { useAppSelector } from '../../../state/hooks'
import { selectSaleFinals } from '../../../state/slices/currentSale/currentSaleSlice'
import { EcomCustomCharge } from '../../../models/sale'
import { useFormatCurrencyValue } from './useFormatCurrencyValue'

export const SubtotalEcomCustomCharges: FunctionComponent = () => {
  const formatCurrencyValue = useFormatCurrencyValue()
  const saleFinals = useAppSelector(selectSaleFinals)
  const hasEcomCustomCharges = !vn(saleFinals.ecomCustomCharges?.totalIncl).eq(
    0
  )
  const hasTaxedEcomCustomCharges = !vn(
    saleFinals.ecomCustomCharges?.totalTax
  ).eq(0)

  const getEcomCustomChargeLabel = (charge: EcomCustomCharge) => {
    if (!hasTaxedEcomCustomCharges) {
      return charge.name
    }

    return (
      <T
        _str="{chargeName} (tax incl.)"
        _context="Sale summary ecom custom charge line"
        chargeName={charge.name}
      />
    )
  }

  if (!hasEcomCustomCharges) {
    return null
  }

  return saleFinals.ecomCustomCharges!.charges.map(charge => {
    return (
      <li className="sale-summary-line vd-pt2" key={charge.sourceId}>
        <div className="sale-summary-line-item sale-summary-line-item--label">
          {getEcomCustomChargeLabel(charge)}
        </div>
        <div className="sale-summary-line-item sale-summary-line-item--value">
          {formatCurrencyValue(charge.totalIncl)}
        </div>
      </li>
    )
  })
}
